module.exports = __webpack_public_path__ + "static/media/Blog_Increase Review Count (1).79ce3791.webp";